import { IRequestData } from '@zet/customer/src/api/functions/customerAdditionStateMachine'

export const getFormatRequestData = (data: IRequestData) => {
  const {
    email,
    employmentType,
    fullName,
    annualIncome,
    phoneNumber,
    pinCode,
    modeOfIncome,
    screenName,
    panNo,
    dob,
    otp,
    customerId,
    jfsConsent,
  } = data
  switch (screenName) {
    case 'SHOWN_QUICK_BASIC_DETAILS_SCREEN':
      return {
        customerZetPartnerBody: {
          customerPayload: {
            fullName,
            phoneNumber,
            pinCode,
            employmentType,
            monthlyIncome: annualIncome,
            modeOfIncome,
            email,
          },
          userState: screenName,
        },
        source: 'zet-partner',
      }
    case 'SHOWN_QUICK_OTP_SCREEN':
      return {
        customerZetPartnerBody: {
          customerPayload: {
            otp,
            phoneNumber,
            customerId,
          },
          userState: screenName,
        },
        source: 'zet-partner',
      }
    case 'SHOWN_QUICK_PAN_SCREEN':
      return {
        customerZetPartnerBody: {
          customerPayload: {
            panNo,
            dob,
            customerId,
          },
          userState: screenName,
        },
        source: 'zet-partner',
      }
    case 'SHOWN_PRIMARY_DETAILS_SCREEN_JFS':
      return {
        customerZetPartnerBody: {
          customerPayload: {
            phoneNumber,
            fullName,
            email,
            customerId,
            jfsConsent,
          },
          userState: screenName,
        },
        source: 'zet-partner',
      }
    case 'SHOWN_BASIC_DETAILS_SCREEN_JFS':
      return {
        customerZetPartnerBody: {
          customerPayload: {
            pinCode,
            employmentType,
            monthlyIncome: annualIncome,
            modeOfIncome,
            customerId,
          },
          userState: screenName,
        },
        source: 'zet-partner',
      }
    case 'SHOWN_PAN_SCREEN_JFS':
      return {
        customerZetPartnerBody: {
          customerPayload: {
            panNo,
            dob,
            customerId,
          },
          userState: screenName,
        },
        source: 'zet-partner',
      }
  }
}
